import { Search } from 'lucide-react';
import { OrgSwitcher } from './org-switcher';
import { UserMenu } from './user-menu';

export function Header() {
  return (
    <header className="flex h-14 items-center justify-between border-b border-border bg-surface px-4">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-red-accent">
            <svg width="20" height="14" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 2L24 6.5V17.5L16 22L8 17.5V6.5L16 2Z" stroke="#F0F0F5" strokeWidth="1.3" fill="#0A0A0F" />
              <path d="M10 7L4 4" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M9 10L3 10" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M9 14L3 14" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M10 17L4 20" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M22 7L28 4" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M23 10L29 10" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M23 14L29 14" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M22 17L28 20" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M16 8L20 10.5V15.5L16 18L12 15.5V10.5L16 8Z" fill="#F2555A" />
              <circle cx="16" cy="12" r="1.5" fill="#E5484D" />
            </svg>
          </span>
          <span className="text-lg font-bold text-text-primary">Redbax</span>
        </div>
        <OrgSwitcher />
      </div>
      <div className="flex items-center gap-3">
        <button
          disabled
          className="flex items-center gap-2 rounded-md border border-border bg-surface px-3 py-1.5 text-sm text-text-secondary opacity-50"
          aria-label="Search (coming soon)"
        >
          <Search className="h-4 w-4" />
          <span className="hidden sm:inline">Search...</span>
        </button>
        <UserMenu />
      </div>
    </header>
  );
}
